// Certaines bibliotheques attendent `global` (Node). Le definir ici plutot que par
// `define` dans vite.config : en build, `define` remplacait aussi le mot dans les
// chaines, et /kpis/global-overview devenait /kpis/globalThis-overview (404 en prod).
if (typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}
